@if (grow) {
	<div class="spinner-grow spinner-grow-sm" role="status">
		<span class="visually-hidden">Loading...</span>
	</div>
} @else {
	<div class="d-flex w-100 align-items-center justify-items-center flex-column animated--fade-in-up"
		 [class.p-3]="large" [class.p-sm-5]="large">
		<div class="spinner-border"
			 [class.mb-2]="showMessage"
			 [class.spinner-border-xl]="large"
			 [class.spinner-border-sm]="!large" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
		@if (showMessage) {
			@if (large) {
				<h3 class="fw-200 text-center">{{ msg ?? 'Carregando informações, aguarde...' }}</h3>
			} @else {
				<small class="fw-200 text-center">{{ msg ?? 'Carregando informações, aguarde...' }}</small>
			}
		}
	</div>
}